import { render, staticRenderFns } from "./commonDialog.vue?vue&type=template&id=0a8f3f51&scoped=true"
import script from "./commonDialog.vue?vue&type=script&lang=js"
export * from "./commonDialog.vue?vue&type=script&lang=js"
import style0 from "./commonDialog.vue?vue&type=style&index=0&id=0a8f3f51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8f3f51",
  null
  
)

export default component.exports